export default {
  // personal
  1: 'You got a new task',
  2: 'You\'re mentioned in the chat',
  3: 'You\'re mentioned in a discussion',
  4: 'You\'re mentioned in a page',
  5: 'You\'re mentioned in a event',
  6: 'You\'re mentioned in a comment',
  7: 'You\'re added to a new space',
  8: 'You\'re mentioned in a task',
  9: 'You\'re assigned to the task',
  // general
  100: 'A new team member joined',
  101: 'A space has been removed',
  102: 'A new page was created',
  103: 'There\'s a new discussion',
  104: 'There are new chat messages',
  105: 'A spaces title was changed'
}
